let isDownloadingDocument = false

export const suppressBeforeUnloadForDownload = () => {
  isDownloadingDocument = true
  setTimeout(() => { isDownloadingDocument = false }, 3000)
}

export const InvoiceEditConfirmTabCloseMixin = {
  data () {
    return {
      isShowCreationForm: false
    }
  },
  watch: {
    value: function (val) {
      if (val) {
        window.addEventListener('beforeunload', this.handleBeforeUnload)
      } else {
        window.removeEventListener('beforeunload', this.handleBeforeUnload)
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  },
  methods: {
    handleBeforeUnload (event) {
      if (isDownloadingDocument) return

      if (this.$v.form.fields.$anyDirty) {
        event.preventDefault() // Recommended for best compatibility

        // Included for legacy support, e.g. Chrome/Edge < 119
        event.returnValue = true
      }
    }
  }
}
